import type { GridMap } from "./GridMap.js";

/**
 * Engine-wide singleton reference to the active `GridMap`.
 *
 * `main.tsx` constructs a fresh GridMap per map load; UI surfaces that
 * need spatial info (the spell-targeting battle board's line-of-sight
 * shading, etc.) read it via `getGridMap()`. Mirrors the
 * `combatManagerRef` pattern.
 */

let _gridMap: GridMap | null = null;

export function setGridMap(g: GridMap | null): void {
  _gridMap = g;
}

export function getGridMap(): GridMap | null {
  return _gridMap;
}
